<template>
    <transition name="modal-animation" duration="400">
        <div class="modal" v-if="showModal" :class="customClass">
            <div class="modal__inner">
                <div class="modal__header">
                    <slot name="modal-header"></slot>
                    <button class="close-btn" @click="closeModalClicked" v-if="closeBtn">
                        <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1l12 12" stroke="#555" stroke-width="2" fill="none" fill-rule="evenodd" opacity=".332"></path>
                        </svg>
                    </button>
                </div><!-- /.modal__header -->
                <div class="modal__body">
                    <slot name="modal-body"></slot>
                </div><!-- /.modal__body -->
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['showModal', 'closeBtn', 'customClass'],
        methods: {
            closeModalClicked() {
                this.$emit('closeModalClickedHandler');
            }
        }
    }
</script>
<style lang="scss">
    @import "./src/styles/generic/settings";
    @import "./src/styles/components/modal";
</style>